import React, { useState, useEffect } from 'react';
import './Navigation.css';
import LogoMark from './LogoMark';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'About', section: 'about' },
    { label: 'Services', section: 'services' },
    { label: 'Method', section: 'method' },
    { label: 'Case Studies', section: 'cases' },
  ];

  const mobileLinks = [
    ...navLinks,
    { label: 'Leadership', section: 'founder' },
    { label: 'Contact', section: 'contact' },
  ];

  return (
    <nav id="nav" className={isScrolled || isMobileMenuOpen ? 'sc' : ''}>
      <div className="ni">
        <LogoMark onClick={() => scrollToSection('hero')} />
        <ul className="nls">
          {navLinks.map((link) => (
            <li key={link.section}>
              <a
                href={`#${link.section}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.section);
                }}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contact"
              className="ncta"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
            >
              Engage Us
            </a>
          </li>
        </ul>
        <button
          className={`nhb ${isMobileMenuOpen ? 'op' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div className={`nm ${isMobileMenuOpen ? 'op' : ''}`}>
        {mobileLinks.map((link) => (
          <a
            key={link.section}
            href={`#${link.section}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(link.section);
            }}
          >
            {link.label}
          </a>
        ))}
        <a
          href="#contact"
          className="nmcta"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('contact');
          }}
        >
          Engage Us
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
